import { render, staticRenderFns } from "./MppUser.vue?vue&type=template&id=03f4dba2&scoped=true"
import script from "./MppUser.vue?vue&type=script&lang=js"
export * from "./MppUser.vue?vue&type=script&lang=js"
import style0 from "./MppUser.vue?vue&type=style&index=0&id=03f4dba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f4dba2",
  null
  
)

export default component.exports